import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["card", "checkbox", "tilesContainer"]
  
  complete(event) {
    event.preventDefault()
    
    const todoId = event.target.dataset.todoId || event.target.closest('[data-todo-id]')?.dataset.todoId
    const todoCard = this.findTodoCard(event.target)
    
    if (!todoId || !todoCard) {
      return
    }
    
    // Starte Animation
    this.startCompletionAnimation(todoCard)
    
    // Sende Turbo-Request
    const form = document.createElement('form')
    form.method = 'POST'
    form.action = `/backend/todos/${todoId}/complete`
    form.style.display = 'none'
    
    // CSRF Token hinzufügen
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content
    if (csrfToken) {
      const csrfInput = document.createElement('input')
      csrfInput.type = 'hidden'
      csrfInput.name = 'authenticity_token'
      csrfInput.value = csrfToken
      form.appendChild(csrfInput)
    }
    
    // Method Override für PUT
    const methodInput = document.createElement('input')
    methodInput.type = 'hidden'
    methodInput.name = '_method'
    methodInput.value = 'put'
    form.appendChild(methodInput)
    
    document.body.appendChild(form)
    form.submit()
    
    // Entferne Form nach Submission
    setTimeout(() => {
      if (document.body.contains(form)) {
        document.body.removeChild(form)
      }
    }, 100)
  }
  
  startCompletionAnimation(card) {
    // Füge Animation-Klassen hinzu
    card.classList.add('completing')
    
    // Entferne Card nach Animation
    setTimeout(() => {
      card.classList.add('todo-fade-out')
      
      // Entferne Card komplett nach Animation
      setTimeout(() => {
        if (card.parentNode) {
          card.parentNode.removeChild(card)
        }
      }, 400)
    }, 200)
  }
  
  findTodoCard(element) {
    // Suche nach der Todo-Card (kann in verschiedenen Verschachtelungen sein)
    let current = element
    while (current && !current.classList.contains('todo-card')) {
      current = current.parentElement
    }
    return current
  }
  
  // Turbo Stream Handler für Server-seitige Updates
  connect() {
    this.element.addEventListener('turbo:before-stream-render', (event) => {
      const stream = event.detail.newStream
      const action = stream.getAttribute('action')
      const target = stream.getAttribute('target')
      
      if (action === 'remove' && target.startsWith('todo-')) {
        const todoCard = document.getElementById(target)
        if (todoCard) {
          this.startCompletionAnimation(todoCard)
        }
      }
    })
  }
}
